import React from "react";
import { useRouteMatch, Switch } from "react-router-dom";

import AuthenticatedRoute from "../../../middlewares/AuthenticatedRoute";

import LanguageMasters from "./LanguageMasters";
import DialectMasters from "./DialectMasters";
import UserMaster from "./UserMaster";
import TermsAndConditionsMaster from "./TermsAndConditionsMaster";
import RateStructuresMaster from "./RateStructuresMaster";
import ClientMasters from "./ClientMasters";

const Index = () => {
  let { url } = useRouteMatch();

  return (
    <Switch>
      <AuthenticatedRoute permission="languages" path={`${url}/languages`}>
        <LanguageMasters />
      </AuthenticatedRoute>
      <AuthenticatedRoute permission="dialects" path={`${url}/dialects`}>
        <DialectMasters />
      </AuthenticatedRoute>
      <AuthenticatedRoute permission="terms" path={`${url}/termsAndConditions`}>
        <TermsAndConditionsMaster />
      </AuthenticatedRoute>
      <AuthenticatedRoute permission="users" path={`${url}/users`}>
        <UserMaster />
      </AuthenticatedRoute>
      <AuthenticatedRoute permission="rates" path={`${url}/rateStructures`}>
        <RateStructuresMaster />
      </AuthenticatedRoute>
      <AuthenticatedRoute permission="clients" path={`${url}/clients`}>
        <ClientMasters />
      </AuthenticatedRoute>
      {/* <Route path="">
        <LanguageMasters />
      </Route> */}
    </Switch>
  );
};

export default Index;
